import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const TESTIMONIALS = [{
  quote: 'Me ayudó a bajar el ritmo sin sentir culpa. Lo leí en dos días y volví a varios ejercicios.',
  name: 'María L.'
}, {
  quote: 'Por fin alguien explica la autoexigencia sin sermones. Se lo recomendé a tres amigas.',
  name: 'Luciana R.'
}, {
  quote: 'El diario de 7 días me hizo ver patrones que no notaba. Muy práctico y sin florituras.',
  name: 'Carla S.'
}];
export function Testimonials() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-124" data-mp="2x0tbw3h65ugz">
      <div className="mx-auto max-w-5xl px-6" data-id="element-125" data-mp="2x1bhhqpq1l1k">
        <SectionHeading eyebrow="Testimonios" title="Lo que dicen quienes lo leyeron" data-id="element-126" data-mp="2s1ymujslz9of" />
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-127" data-mp="v9ooxkq6li2z">
          {TESTIMONIALS.map((t, i) => <motion.blockquote key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.55,
          ease: 'easeOut',
          delay: i * 0.1
        }} className="flex h-full flex-col justify-between bg-cream-deep p-8" data-id="element-128" data-mp="qbeujcca6lif" data-mpi={i}>
              <p className="font-serif text-xl italic leading-snug text-ink" data-id="element-129" data-mp="14vsi0m9tcjj4">
                “{t.quote}”
              </p>
              <footer className="mt-6 font-sans text-xs uppercase tracking-[0.2em] text-muted" data-id="element-130" data-mp="q5v20tm1f050">
                {t.name}
              </footer>
            </motion.blockquote>)}
        </div>
      </div>
    </section>;
}